import { Column, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { CxQuestionPage } from "./cx-question-page.entity";
// import { Shop } from "./shop.entity";
// CxQuestionHeaderはCxBrandに紐づくよう仕様変更
import { CxBrand } from "./cx-brand.entity";
// import { CxShopToken } from "./cx-shop-token.entity";
// CxQuestionHeaderはCxBrandに紐づく

@Entity()
export class CxQuestionHeader extends CommonColumns {

  // @ManyToOne(() => Shop, shop => shop.questionHeaders, { nullable: false, })
  // @JoinColumn({ name: 'shop_id', referencedColumnName: 'id', })
  // shop: Shop;

  // @Column({ name: 'shop_id', })
  // shopId: number;
  // CxBrandに紐づけるよう仕様変更
  @ManyToOne(() => CxBrand, cxBrand => cxBrand.cxQuestionHeaders, { nullable: false, })
  @JoinColumn({ name: 'cx_brand_id', referencedColumnName: 'id', })
  cxBrand: CxBrand;

  @Column({ name: 'cx_brand_id', })
  cxBrandId: number;

  @Column()
  name: string;

  @Column()
  is_latest: boolean;

  // @OneToMany(() => CxShopToken, cxShopToken => cxShopToken.cxQuestionHeader)
  // cxShopTokens: CxShopToken[];
  // CxQuestionHeaderはCxBrandに紐づく

  @OneToMany(() => CxQuestionPage, cxQuestionPage => cxQuestionPage.cxQuestionHeader)
  cxQuestionPages: CxQuestionPage[];

  constructor(props: TCxQuestionHeader) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxQuestionHeader = Omit<CxQuestionHeader, 'dummy-no-such-field'>;
export interface ICxQuestionHeader extends TCxQuestionHeader {};
